
<mcg-loader [showLoader]="showLoader"></mcg-loader>
<div #puContainer id="puGrid" style="overflow: hidden; height: 100%;">
  <jqxGrid #gridPU  [theme]="environment.tema" [height]="'100%'"
    [width]="'100%'" [appCellClick] [columnsresize]="true" [sortable]="true" [selectionmode]="'checkbox'"
    [groupable]="true" [showrowlines]="false" [rendertoolbar]="createToolBar" [showcolumnlines]="true"
    [showtoolbar]="true" [altrows]="true" [sortmode]="'many'" [toolbarheight]="30" [groupsheaderheight]="20"
    [filterable]="true" [columnmenuopening]="columnmenuopening" [showaggregates]="true" [showstatusbar]="true"
    [statusbarheight]="20" [autoshowfiltericon]="true" [filterrowheight]="20" [rowsheight]="25" [columnsheight]="20"
    [enablebrowserselection]="true" [localization]="langGrid" [filter]="filter" [columns]="columns" [source]="dataAdapter"
    [updatefilterconditions]="updatefilterconditions" (onCellclick)="onCellClick($event)"
    (onBindingcomplete)="onBindingComplete()" (onFilter)="onChangeFilter($event)"
    (onRowdoubleclick)="onRowdoubleclick($event)">
  </jqxGrid>
</div>

<ng-template #btnTemplate>
  <div class="btn-container" style="display: flex; justify-content: flex-start; gap: 2px; padding: 2px;">
    <button class="button" (click)="onEdit()" style="height: 23px; cursor: pointer;" title="Editar">
      <i class="fa-solid fa-pen-to-square"></i>
    </button>
    <button class="button" (click)="onPosicionar()" style="height: 23px; cursor: pointer;" title="Posicionar">
      <i class="fa-solid fa-location-dot"></i>
    </button>
    <button class="button" (click)="onDelete()" style="height: 23px; cursor: pointer;" title="Borrar">
      <i class="fa-solid fa-trash"></i>
    </button>
  </div>
</ng-template>
